export const SUPPORTED_LANGUAGES = ['en', 'ro', 'ru'] as const

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export const resolveLanguageKey = (
  lang: string | undefined
): SupportedLanguage => {
  const base = (lang ?? 'en').toLowerCase().split('-')[0] || 'en'

  return (SUPPORTED_LANGUAGES as readonly string[]).includes(base)
    ? (base as SupportedLanguage)
    : 'en'
}
